// extracted by mini-css-extract-plugin
export default {"label":"File_label__7eIgT","tooltip":"File_tooltip__uOXos","wrap":"File_wrap__eE4XQ","input":"File_input__th8Z8","box":"File_box__woyRe"};